// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container_326c12 .ant-radio-button-wrapper {\n    padding: 0 8px !important;\n}", "",{"version":3,"sources":["webpack://src/app/pages/reviewer/components/TooltipSquareRadioButton/index.module.scss"],"names":[],"mappings":"AACE;IACE,yBAAA;AAAJ","sourcesContent":[".container {\n  :global(.ant-radio-button-wrapper) {\n    padding: 0 8px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container_326c12"
};
export default ___CSS_LOADER_EXPORT___;
